import { Turbo } from '@hotwired/turbo-rails'
import * as ActiveStorage from '@rails/activestorage'
import 'bootstrap'
import './controllers'
import './utils/initialize_bootstrap'

ActiveStorage.start()

Turbo.config.drive.progressBarDelay = 20
